import request from '@/utils/request'

// 查询剧本集列表
export function listSheet(query) {
  return request({
    url: '/script/sheet/list',
    method: 'get',
    params: query
  })
}

// 查询剧本集详细
export function getSheet(id) {
  return request({
    url: '/script/sheet/' + id,
    method: 'get'
  })
}

// 新增剧本集
export function addSheet(data) {
  return request({
    url: '/script/sheet',
    method: 'post',
    data: data
  })
}

// 修改剧本集
export function updateSheet(data) {
  return request({
    url: '/script/sheet',
    method: 'put',
    data: data
  })
}

// 删除剧本集
export function delSheet(id) {
  return request({
    url: '/script/sheet/' + id,
    method: 'delete'
  })
}
